"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBillingApiClient = exports.BillingHttpClient = exports.billingInstance = void 0;
const src_1 = require("./billing/src");
const axios_1 = __importDefault(require("axios"));
const request_1 = require("./billing/src/__generated__/core/request");
// export all sdk
__exportStar(require("./billing/src"), exports);
let token = '';
const billingInstance = (baseUrl) => {
    return axios_1.default.create({
        baseURL: baseUrl,
        headers: {
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : undefined,
        },
    });
};
exports.billingInstance = billingInstance;
class BillingHttpClient extends src_1.BaseHttpRequest {
    axiosInstance;
    constructor(config) {
        super(config);
        this.axiosInstance = (0, exports.billingInstance)(config.BASE);
    }
    request(options) {
        return (0, request_1.request)(this.config, options, this.axiosInstance);
    }
}
exports.BillingHttpClient = BillingHttpClient;
const createBillingApiClient = (baseUrl, tokenProp) => {
    token = tokenProp;
    return new src_1.Billing({
        BASE: baseUrl,
    }, BillingHttpClient);
};
exports.createBillingApiClient = createBillingApiClient;
